import { Injectable, signal } from '@angular/core';
import { UserRoutes } from './core/models/user-routes.model';
import { Customer } from './shared/models/customer/customer.model';
import { User } from './shared/services/user/models/user.model';

@Injectable({ providedIn: 'root' })
export class AppState {
    public customer$ = signal<Customer>(null);
    public user$ = signal<User>(null);
    public userRoutes$ = signal<UserRoutes>(null);
    public lastRetrievalDate = new Date();
    public refreshTokenCountSignal = signal<number>(0);
}
